var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/ExplorerBody/ExplorerItem.tsx";
import React from 'react';
import { useExplorerProps } from '../propsCtx';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExplorerItem({
  item,
  isSelected,
  onSelect,
  getScrollElem
}) {
  const {
    ItemRenderer
  } = useExplorerProps();
  const [loading, setLoading] = React.useState(false);

  const onSelectHandler = noFetch => {
    const prom = onSelect(item, noFetch);

    if (prom instanceof Promise) {
      setLoading(true);
      prom.finally(() => setLoading(false));
    }
  };

  const ref = React.useRef(null);
  const getRef = React.useCallback(() => ref, []);
  React.useEffect(() => {
    const win = getScrollElem();
    const el = ref.current;

    if (isSelected && win && el) {
      const wh = win.getClientHeight();
      const ot = el.offsetTop;
      const result = ot - wh;
      win.scrollTop(result + wh / 2);
    } // Грязный хак чтобы скроллить только при первом рендере
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsx(ItemRenderer, {
    item: item,
    loading: loading,
    onSelect: onSelectHandler,
    selected: isSelected,
    getRef: getRef
  });
}
ExplorerItem.displayName = 'ExplorerItem';